import React from 'react';
import DialogList from '../SecComponents/dialogList';

const availableReferences = {
  message: 'Por favor, indique alguna de las referencias:',
  optionList: [
    'No. de Ingreso',
    'No. de Despacho',
    'Referencia',
    'Documento de Transporte',
  ],
};

function AlmacenDocumentos() {
  return (
    <div>
      <DialogList references={availableReferences} />
    </div>
  );
}

export default AlmacenDocumentos;
